import { ru, enUS } from 'date-fns/locale'

export const dateLocales = {
  ru: ru,
  en: enUS
}

export const dateFormat = {
  ru: 'dd.MM.yyyy, HH:mm:ss (OO)',
  en: 'MM.dd.yyyy, HH:mm:ss (OO)'
}
